import { faThumbsUp } from "@fortawesome/free-regular-svg-icons";
import { faThumbsUp as faThumbsUpSolid } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import { Button } from "@progress/kendo-react-buttons";
import { VendorUserType } from "auth/VendorAuth/vendorUserSlice";
import axios from "axios";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { useState } from "react";
import { showApiErrorMessage, showErrorMessage } from "store/errorModalSlice";
import { selectRfi, upvoteVendorQuestion } from "store/rfiSlice";
import { selectVendorResponse } from "store/vendorResponseSlice";
import { ElementVendorQuestion } from "../../types/RfiTypes";

interface IQandAProps {
  question: ElementVendorQuestion;
  user?: VendorUserType;
  isQAOpen: boolean;
}

const QandA = (props: IQandAProps) => {
  dayjs.extend(utc);

  // Hooks
  const rfi = useAppSelector(selectRfi);
  const vendorResponse = useAppSelector(selectVendorResponse);
  const dispatch = useAppDispatch();

  // State
  const [isUpdating, setIsUpdating] = useState(false);

  // Handlers
  const handleVote = () => {
    setIsUpdating(true);

    let requestData = {
      vendorQuestionId: props.question.rfxVendorQuestionId,
      upvote: 1,
    };
    axios
      .post(
        `/api/v1/rfi/${rfi.rfi?.rfiId}/VendorQuestions/VoteOnVendorQuestion`,
        requestData
      )
      .then((res) => {
        setIsUpdating(false);
        dispatch(upvoteVendorQuestion(props.question.rfxVendorQuestionId));
      })
      .catch((error) => {
        setIsUpdating(false);

        typeof error.response?.data?.[0]?.error?.message === "undefined"
          ? dispatch(
              showErrorMessage(
                `Error submitting Vendor Vote - ${error.message}`
              )
            )
          : dispatch(showApiErrorMessage({ errorResponse: error }));
      });
  };

  // const renderTooltip = (questionText) => (
  //   <Tooltip id="text-tooltip" {...props}>
  //   questionText
  // </Tooltip>
  // );

  // {rfi.rfi?.title.length && rfi.rfi?.title?.length <= 100 && (
  //   <h1 className="h3 mb-0" id="rfiName">
  //     {rfi.rfi?.title}
  //   </h1>
  // )}
  // {rfi.rfi?.title?.length && rfi.rfi?.title?.length > 100 && (
  //   <Tooltip title={rfi.rfi?.title} placement="top">
  //     <h1 className="h3 mb-0" id="rfiName" aria-label={rfi.rfi?.title}>
  //       {`${rfi.rfi?.title.substring(0, 100)}…`}{" "}
  //     </h1>
  //   </Tooltip>
  // )}

  // Render
  return (
    <div style={{ marginLeft: "25px", marginBottom: "25px" }}>
      {props.question.answerStatus !== "Feedback" && (
        <span>
          <strong>Q: </strong>
          {props.question.questionText?.length &&
            props.question.questionText?.length <= 100 && (
              <span>{props.question.questionText}</span>
            )}
          {props.question.questionText?.length &&
            props.question.questionText?.length > 100 && (
              <Tooltip title={props.question.questionText} placement="top">
                <span>
                  {`${props.question.questionText.substring(0, 100)}…`}{" "}
                </span>
              </Tooltip>
            )}
        </span>
      )}
      {props.question.answerStatus === "Feedback" && (
        <span>
          <strong>My Feedback: </strong>
          {props.question.questionText?.length &&
            props.question.questionText?.length <= 100 && (
              <span>{props.question.questionText}</span>
            )}
          {props.question.questionText?.length &&
            props.question.questionText?.length > 100 && (
              <Tooltip title={props.question.questionText} placement="top">
                <span>
                  {`${props.question.questionText.substring(0, 100)}…`}{" "}
                </span>
              </Tooltip>
            )}
        </span>
      )}
      <span style={{ marginLeft: "10px" }}>
        {props.question.answerStatus !== "Feedback" &&
        props.user &&
        props.user.isAuthenticated &&
        props.question.isMine !== "true" &&
        props.question.didIVote !== "true" &&
        props.isQAOpen ? (
          isUpdating ? (
            <div className="threeBallsFalling"></div>
          ) : (
            <Button
              aria-label="I have the same question"
              title="I have the same question"
              onClick={handleVote}
            >
              <FontAwesomeIcon
                icon={faThumbsUp}
                size="lg"
                style={{ color: "#2b62bf" }}
              />
            </Button>
          )
        ) : (
          ""
        )}
        {props.user &&
          props.user.isAuthenticated &&
          props.question.isMine !== "true" &&
          props.question.didIVote === "true" && (
            <FontAwesomeIcon
              aria-label="I voted for this question"
              title="I voted for this question"
              icon={faThumbsUpSolid}
              size="lg"
              style={{ color: "#2b62bf" }}
            />
          )}
      </span>
      <br />

      {props.question.answerStatus !== "Feedback" && (
        <em style={{ marginLeft: "20px", fontSize: ".85rem" }}>
          {" "}
          Asked {props.question.voteCount + 1}{" "}
          {props.question.voteCount + 1 === 1 ? "time" : "times"}{" "}
        </em>
      )}
      {props.question.answerStatus !== "Feedback" &&
        props.user &&
        props.user.isAuthenticated &&
        (props.question.isMine === "true" ||
          props.question.didIVote === "true") && (
          <>
            <em style={{ fontSize: ".85rem" }}> (including by me) </em>
            <br />
          </>
        )}
      <br />
      {props.question.answerText && (
        <>
          <span style={{ marginLeft: "30px" }}>
            {" "}
            <strong>A:</strong> {props.question.answerText}
          </span>
          <br />
        </>
      )}
    </div>
  );
};

export default QandA;
